module.exports = __webpack_public_path__ + "img/ydyl-td.0a26afc7.png";